var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5C4 5.09987 4 4.3998 4.28027 3.86502C4.5268 3.39462 4.92018 3.01217 5.40402 2.77248C5.95408 2.5 6.67415 2.5 8.11429 2.5H11.8857C13.3258 2.5 14.0459 2.5 14.596 2.77248C15.0798 3.01217 15.4732 3.39462 15.7197 3.86502C16 4.3998 16 5.09987 16 6.5V13.4212C16 14.7631 16 15.434 15.7179 15.8264C15.4717 16.1687 15.0928 16.3917 14.674 16.4406C14.194 16.4967 13.6075 16.1708 12.4345 15.5191L10 14.1667L7.56554 15.5191C6.39252 16.1708 5.806 16.4967 5.32599 16.4406C4.90717 16.3917 4.52828 16.1687 4.28213 15.8264C4 15.434 4 14.7631 4 13.4212V6.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIconFavorite);
export default __webpack_public_path__ + "static/media/default-icon-favorite.c549aa0ef80083b37404b9ae33c9121a.svg";
export { ForwardRef as ReactComponent };